import { Card } from 'react-bootstrap';
import chatIllustration from 'assets/img/spot-illustrations/chat.webp';
import chatDarkIllustration from 'assets/img/spot-illustrations/dark_chat.webp';
import Scrollbar from 'components/base/Scrollbar';
import { useChatContext } from './AIChatProvider';
import { useTranslation } from 'react-i18next';
import AIChatContent from './AIChatContent';

const AIChatHomepageCard = () => {
    const { t } = useTranslation();
    const { currentConversation, startNewChat } = useChatContext();

    if (currentConversation == null) {
        startNewChat();
        {/* 
        return (
            <Card className="h-100 w-100 d-none d-sm-block">
                <Scrollbar>
                    <Card.Body className="h-100 d-flex flex-column flex-center text-center">
                        <img
                            src={chatIllustration}
                            alt="chat"
                            height={260}
                            width={320}
                            className="mb-15 d-dark-none"
                        />
                        <img
                            src={chatDarkIllustration}
                            alt="chat"
                            height={260}
                            width={320}
                            className="mb-15 d-light-none"
                        />
                        <h3 className="text-900 fw-semi-bold mb-3 fs-7 fs-sm-6">
                            {t("AIChatHomepageCard.headline1")},
                        </h3>
                        <h3 className="text-primary fw-semi-bold fs-7 fs-sm-6" style={{ "cursor": "pointer" }} onClick={startNewChat}>
                            {t("AIChatHomepageCard.headline2")}
                        </h3>
                    </Card.Body>
                </Scrollbar>
            </Card>
        );
        */}
    }



    return (
        <AIChatContent />
    )
};

export default AIChatHomepageCard;
